import * as constants from "@/constants";
import { UnworkDayGroup, UnworkDaySearchResult } from "@/models/holiday";

export type HolidayState = {
  unworkDayGroups: UnworkDayGroup[] | undefined; // データ検索していない場合はundefined, 検索して0件の場合は空の配列とする
  expandedRowIndex: number;
  fetching: boolean; // 1クリックで休日を更新できるため排他するためのフラグとして使う
};

export const holiday = (
  state: HolidayState = {
    unworkDayGroups: undefined,
    expandedRowIndex: -1,
    fetching: true,
  },
  action
) => {
  switch (action.type) {
    case constants.UNWORK_DAYS_START_LOADING:
      return { ...state, fetching: true };
    case constants.UNWORK_DAYS_END_LOADING:
      return { ...state, fetching: false };
    case constants.UNWORK_DAYS_END_FETCH: {
      const list: UnworkDaySearchResult[] = action.payload?.list ?? [];
      const groups: UnworkDayGroup[] = list.map((v) => ({ ...v, unwork_days: v.unwork_days.map((d) => new Date(d)) }));
      return { ...state, unworkDayGroups: groups };
    }
    case constants.HOLIDAY_EXPAND_ROW:
      return { ...state, expandedRowIndex: action.payload };
    case constants.UNWORK_DAYS_BEGIN_UPDATE:
      return { ...state, fetching: true };
    case constants.UNWORK_DAYS_END_UPDATE: {
      const groups = state.unworkDayGroups.concat();
      const result: UnworkDaySearchResult = action.payload;
      const target = { ...result, unwork_days: result.unwork_days.map((d) => new Date(d)) };
      groups.splice(state.expandedRowIndex, 1, target);
      return { ...state, fetching: false, unworkDayGroups: groups };
    }
    case constants.APP_SHOW_ERROR:
      return { ...state, fetching: false };
    default:
      return state;
  }
};
